import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = _resolveComponent("Icon");
    const _component_MessageBoxPlain = _resolveComponent("MessageBoxPlain");
    return (_openBlock(), _createBlock(_component_MessageBoxPlain, {
        variant: _ctx.variant,
        message: _ctx.message,
        title: _ctx.title
    }, _createSlots({
        icon: _withCtx(() => [
            _createVNode(_component_Icon, {
                name: _ctx.iconName,
                title: _ctx.iconTitle
            }, null, 8, ["name", "title"])
        ]),
        _: 2
    }, [
        (_ctx.$slots['message'])
            ? {
                name: "message",
                fn: _withCtx((scope) => [
                    _renderSlot(_ctx.$slots, "message", _normalizeProps(_guardReactiveProps(scope)))
                ]),
                key: "0"
            }
            : undefined
    ]), 1032, ["variant", "message", "title"]));
}
